import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01083fea")

_pushScopeId("data-v-01083fea")
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_category",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row align-items-end g-9" }
const _hoisted_9 = { class: "col-md-9 fv-row" }
const _hoisted_10 = { class: "col-md-3 fv-row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "d-flex flex-column  fv-row" }
const _hoisted_13 = { class: "required d-flex align-items-center fs-6 fw-bold mt-2" }
const _hoisted_14 = {
  key: 0,
  class: "errors"
}
const _hoisted_15 = { class: "fv-row mb-5 account-status" }
const _hoisted_16 = { class: "d-flex flex-stack" }
const _hoisted_17 = { class: "me-5 account-status-msg-area" }
const _hoisted_18 = { class: "fs-5 fw-bold" }
const _hoisted_19 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_20 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_21 = {
  key: 0,
  class: "col-md-12 upload-image-col"
}
const _hoisted_22 = { class: "upload-image-box" }
const _hoisted_23 = { class: "upload-box" }
const _hoisted_24 = { class: "add-image" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-camera-retro" })
], -1)
const _hoisted_26 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_27 = { class: "hover-effect" }
const _hoisted_28 = { class: "image-heading" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_31 = { class: "modal-footer flex-center" }
const _hoisted_32 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_33 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Image = _resolveComponent("Image")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: "addCategoryForm",
          model: _ctx.addCategoryData
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(_ctx.$t('message.ADD')) + " " + _toDisplayString(_ctx.$t('message.CATEGORY')), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "name",
                      label: `${_ctx.$t('message.NAME')} (${_ctx.addCategoryData.locale})`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                      requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.addCategoryData.name = $event)),
                      target: "name",
                      required: true,
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue(_ctx.addCategoryData.name))),
                      value: _ctx.addCategoryData.name
                    }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Select, {
                      name: "locale",
                      target: "locale",
                      callEmit: true,
                      required: false,
                      label: false,
                      locale: _ctx.addCategoryData.locale,
                      "onUpdate:locale": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addCategoryData.locale = $event)),
                      selectData: _ctx.locales,
                      value: _ctx.addCategoryData.locale,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLang(_ctx.addCategoryData.locale)))
                    }, null, 8, ["locale", "selectData", "value"])
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode(_component_el_tabs, {
                      modelValue: _ctx.tabsValue,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.tabsValue = $event)),
                      type: "card",
                      onTabClick: _ctx.tabClickHandler
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locales, (item) => {
                          return (_openBlock(), _createBlock(_component_el_tab_pane, {
                            key: item.value,
                            label: item.label,
                            name: item.value
                          }, null, 8, ["label", "name"]))
                        }), 128)),
                        _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('message.DESCRIPTION')), 1),
                        _createVNode(_component_QuillEditor, {
                          onTextChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateValueDescription(_ctx.addCategoryData.description))),
                          contentType: "html",
                          ref: "editorForm",
                          theme: "snow",
                          content: _ctx.addCategoryData.description,
                          "onUpdate:content": _cache[6] || (_cache[6] = ($event: any) => (_ctx.addCategoryData.description = $event)),
                          toolbar: "full",
                          placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.META_DESCRIPTION')}`,
                          style: {"height":"250px"}
                        }, null, 8, ["content", "placeholder"]),
                        ((_ctx.addCategoryData.description == '' && _ctx.validate == true) || (_ctx.addCategoryData.description === '<p><br></p>' && _ctx.validate == true))
                          ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('message.DESCRIPTION')) + " " + _toDisplayString(_ctx.$t('message.IS_REQUIRED')), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_Input, {
                          type: "text",
                          name: "metaTitle",
                          label: `${_ctx.$t('message.META_TITLE')} (${_ctx.addCategoryData.locale})`,
                          placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.META_TITLE')}`,
                          requiredMsg: `${_ctx.$t('message.META_TITLE')} ${_ctx.$t('message.IS_REQUIRED')}`,
                          metaTitle: _ctx.addCategoryData.metaTitle,
                          "onUpdate:metaTitle": _cache[7] || (_cache[7] = ($event: any) => (_ctx.addCategoryData.metaTitle = $event)),
                          target: "metaTitle",
                          required: true,
                          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateValueMetaTitle(_ctx.addCategoryData.metaTitle))),
                          value: _ctx.addCategoryData.metaTitle
                        }, null, 8, ["label", "placeholder", "requiredMsg", "metaTitle", "value"]),
                        _createVNode(_component_Input, {
                          type: "textarea",
                          name: "metaDescription",
                          label: `${_ctx.$t('message.META_DESCRIPTION')} (${_ctx.addCategoryData.locale})`,
                          placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.META_DESCRIPTION')}`,
                          requiredMsg: `${_ctx.$t('message.META_DESCRIPTION')} ${_ctx.$t('message.IS_REQUIRED')}`,
                          metaDescription: _ctx.addCategoryData.metaDescription,
                          "onUpdate:metaDescription": _cache[9] || (_cache[9] = ($event: any) => (_ctx.addCategoryData.metaDescription = $event)),
                          target: "metaDescription",
                          required: true,
                          onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateValueMetaDescription(_ctx.addCategoryData.metaDescription))),
                          value: _ctx.addCategoryData.metaDescription
                        }, null, 8, ["label", "placeholder", "requiredMsg", "metaDescription", "value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onTabClick"]),
                    _createVNode(_component_Select, {
                      name: "parent_id",
                      label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.PARENT')} ${_ctx.$t('message.CATEGORY')}`,
                      target: "parent_id",
                      parent_id: _ctx.addCategoryData.parent_id,
                      "onUpdate:parent_id": _cache[12] || (_cache[12] = ($event: any) => (_ctx.addCategoryData.parent_id = $event)),
                      selectData: _ctx.categories,
                      value: _ctx.addCategoryData.parent_id,
                      clearable: true,
                      style: {"margin-top":"15px"}
                    }, null, 8, ["label", "parent_id", "selectData", "value"]),
                    _createVNode(_component_Select, {
                      name: "sites",
                      label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.SITES')}`,
                      required: true,
                      multiple: true,
                      requiredMsg: `${_ctx.$t('message.SITES')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      target: "sites",
                      sites: _ctx.addCategoryData.sites,
                      "onUpdate:sites": _cache[13] || (_cache[13] = ($event: any) => (_ctx.addCategoryData.sites = $event)),
                      selectData: _ctx.set_sites,
                      value: _ctx.addCategoryData.sites
                    }, null, 8, ["label", "requiredMsg", "sites", "selectData", "value"])
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("label", _hoisted_18, _toDisplayString(`${_ctx.$t('message.CATEGORY')}
											${_ctx.$t('message.STATUS')}`), 1),
                        _createVNode("div", _hoisted_19, _toDisplayString(`${_ctx.$t('message.ACCOUNT')}
											${_ctx.$t('message.ACTIVATE_AND_DEACTIVATE')}`), 1)
                      ]),
                      _createVNode("span", _hoisted_20, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.addCategoryData.status,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.addCategoryData.status = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  (_ctx.previewImage.length == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, [
                          _createVNode("div", _hoisted_23, [
                            _createVNode("div", _hoisted_24, [
                              _createVNode("input", {
                                type: "file",
                                class: "upload-btn",
                                accept: "image/png, image/jpg, image/jpeg",
                                onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
                              }, null, 32),
                              _hoisted_25,
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('message.UPLOAD_IMAGES')), 1),
                              _createVNode("span", null, "JPG, GIF " + _toDisplayString(_ctx.$t('message.OR')) + " PNG " + _toDisplayString(_ctx.$t('message.FORMAT')) + " (max size 2MB)", 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.previewImage.length != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _createVNode("img", {
                          src: _ctx.previewImage[0].src,
                          alt: `${_ctx.$t('message.UPLOADED_IMAGES')}`,
                          class: "image-thumbnail",
                          style: {}
                        }, null, 8, ["src", "alt"]),
                        _createVNode("span", _hoisted_28, [
                          _createVNode("i", {
                            class: "fas fa-search",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showMedia(0)))
                          }),
                          _hoisted_29,
                          _createVNode("i", {
                            class: "fas fa-trash-alt",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.removeMedia(0, _ctx.previewImage[0].id)))
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_30,
                _createVNode(_component_Image)
              ])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode("button", _hoisted_32, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submitUserForm()))
              }, [
                _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
})